angular.module('unergie.main')
.controller('bankDetailsModalCtrl', ($scope, $uibModal, $uibModalInstance, ApiUser, FileUploader, CommonRegex, AlertManager, ErrorCatcher, category, value, orgType) => {
    $scope.value = value
    $scope.category = category
    $scope.orgType = orgType
    $scope.bicPattern = CommonRegex.bic
    $scope.payload = {
        iban: '',
        bic: '',
        id_agreement: category.id_agreement_elec || category.id_agreement_gas,
        organization: category.organization,
        treasury_name: null,
        mandatary_mail: null,
        accounting_mail: null,
    }

    $scope.mandateMode = category.payment_mode === 'SEPA'

    $scope.canValidate = () => {
        return value || ($scope.payload.iban
            && $scope.payload.bic
            && $scope.uploader.queue.length
            && (orgType !== 'B2G' || !$scope.mandateMode || $scope.payload.treasury_name) && (!$scope.mandateMode || $scope.payload.mandatary_mail))
    }

    $scope.uploader = new FileUploader({
        alias: 'file',
        url: `/api-user/siret/${category.siret}/iban`,
        formData: [],
        autoUpload: false,
        removeAfterUpload: true,
        method: 'POST',
        onSuccessItem(item, response, status, headers) {
            $uibModalInstance.close({ report_reimbursement: value, success: true })
        },
        onErrorItem(item, response, status, headers) {
            return ErrorCatcher(response)
        },
        onBeforeUploadItem(item) {
            item.url = `/api-user/siret/${category.siret}/iban`
            item.formData.push(_.pickBy($scope.payload))
        },
    })

    $scope.ok = () => (value ? $uibModalInstance.close({ report_reimbursement: value, success: true }) : $scope.uploader.uploadAll())
    $scope.close = () => $uibModalInstance.close({ report_reimbursement: null })
})
